import { api } from './configs/axiosConfig';

const endPoint = "/emailconfig";

export const emailConfigurationAPI = {
    /**
     * Get email configuration for a company
     * @param {string} pCode - Company code
     * @returns {Promise} Email configuration data
     */
    getEmailConfiguration: async function (pCode) {
        try {
            const response = await api.request({
                url: `${endPoint}/${pCode}`,
                method: 'GET'
            });
            return { success: true, data: response.data };
        } catch (error) {
            console.error('Error fetching email configuration:', error);
            throw error;
        }
    },

    /**
     * Save or update email configuration
     * @param {Object} configData - Email configuration data
     * @returns {Promise} Save result
     */
    saveEmailConfiguration: async function (configData) {
        try {
            const response = await api.request({
                url: endPoint,
                method: 'POST',
                data: configData
            });
            return { success: true, data: response.data };
        } catch (error) {
            console.error('Error saving email configuration:', error);
            throw error;
        }
    },

    /**
     * Test email configuration by sending a test email
     * @param {string} pCode - Company code
     * @param {Object} testData - Test email data
     * @returns {Promise} Test result
     */
    testEmailConfiguration: async function (pCode, testData) {
        try {
            const response = await api.request({
                url: `${endPoint}/${pCode}/test`,
                method: 'POST',
                data: testData
            });
            return { success: true, data: response.data };
        } catch (error) {
            console.error('Error testing email configuration:', error);
            throw error;
        }
    },

    /**
     * Get common email provider templates
     * @returns {Object} Email provider configurations
     */
    getEmailProviderTemplates: function () {
        return {
            Gmail: {
                smtpServer: 'smtp.gmail.com',
                smtpPort: 587,
                enableSSL: true,
                emailProvider: 'Gmail',
                instructions: 'Use your Gmail address and App Password (not regular password). Enable 2-factor authentication and generate an App Password.'
            },
            Outlook: {
                smtpServer: 'smtp-mail.outlook.com',
                smtpPort: 587,
                enableSSL: true,
                emailProvider: 'Outlook',
                instructions: 'Use your Outlook.com or Hotmail email address and password.'
            },
            Office365: {
                smtpServer: 'smtp.office365.com',
                smtpPort: 587,
                enableSSL: true,
                emailProvider: 'Office365',
                instructions: 'Use your Office 365 email address and password.'
            },
            Custom: {
                smtpServer: '',
                smtpPort: 587,
                enableSSL: true,
                emailProvider: 'Custom',
                instructions: 'Enter your custom SMTP server settings.'
            },
            Other: {
                smtpServer: '',
                smtpPort: 587,
                enableSSL: true,
                emailProvider: 'Other',
                instructions: 'Configure your custom email provider settings manually.'
            }
        };
    },

    /**
     * Validate email configuration data
     * @param {Object} config - Email configuration to validate
     * @returns {Object} Validation result
     */
    validateEmailConfiguration: function (config) {
        const errors = [];
        console.log('Validating email configuration:', config);
        if (!config.pCode || config.pCode.trim() === '') {
            errors.push('Company code is required');
        }

        if (!config.senderEmail || config.senderEmail.trim() === '') {
            errors.push('Sender email is required');
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(config.senderEmail)) {
            errors.push('Please enter a valid email address');
        }

        if (!config.plainPassword || config.plainPassword.trim() === '') {
            errors.push('Password is required');
        }

        if (!config.smtpServer || config.smtpServer.trim() === '') {
            errors.push('SMTP server is required');
        }

        if (!config.smtpPort || config.smtpPort < 1 || config.smtpPort > 65535) {
            errors.push('Please enter a valid SMTP port (1-65535)');
        }

        return {
            isValid: errors.length === 0,
            errors: errors
        };
    }
};
